// extracted by mini-css-extract-plugin
export default {"dropdown":"style_dropdown__bEOoO","icon":"style_icon__Xvtgk","flag":"style_flag__klpYZ","menuIcon":"style_menuIcon__Qyzrz"};